module.exports = __webpack_public_path__ + "img/right-outfit.4396f3d6.jpg";